import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ScrollToTop from './component/ScrollTop';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';


if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // navigator.serviceWorker.register("/firebase-messaging-sw.js")
    //   .then((registration) => {
    //     console.log("Service Worker registered:", registration);
    //   })
    //   .catch((err) => {
    //     console.log("Service Worker registration failed:", err);
    //   });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>  
  <ScrollToTop />
    <App />    
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
